export default function CTASection() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="rounded-2xl overflow-hidden relative">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20aesthetic%20composition%20of%20fashion%20items%20including%20a%20neatly%20folded%20charcoal%20grey%20knit%20sweater%20and%20a%20pair%20of%20classic%20white%20leather%20sneakers%20on%20a%20light%20beige%20textured%20surface%20with%20soft%20natural%20sunlight%20and%20elegant%20shadows%2C%20editorial%20product%20photography%2C%20elevated%20minimal%20style%2C%20warm%20neutral%20tones&width=1400&height=600&seq=cta-img-v3&orientation=landscape"
            alt="Acessar Hoobuy Spreadsheet Atualizado"
            title="Links Atualizados Hoobuy Spreadsheet"
            className="w-full h-64 md:h-80 object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/25 to-transparent"></div>

          <div className="absolute inset-0 flex flex-col items-center justify-end text-center px-4 pb-8 md:pb-12">
            <p className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-2 max-w-2xl leading-tight">
              Pronto para encontrar os <span className="italic font-light">melhores links</span> do Hoobuy Spreadsheet?
            </p>
            <p className="text-sm md:text-base text-white/70 mb-6 max-w-lg">
              Acesse agora nossa planilha completa com mais de 1000 links atualizados
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-background-50 text-foreground-950 text-sm md:text-base font-semibold hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
            >
              Acessar Links Atualizados
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-sm"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}